import { combineReducers } from '@reduxjs/toolkit'
import layout from './Layout/Layout.slice';
import home from './HomePage/Home.slice';
import blog from './Blog/Blog.slice'

export default combineReducers({
    layout,
    home,
    blog
})